import { render, staticRenderFns } from "./legal_check.vue?vue&type=template&id=2abea2b4&scoped=true"
import script from "./legal_check.vue?vue&type=script&lang=js"
export * from "./legal_check.vue?vue&type=script&lang=js"
import style0 from "./legal_check.vue?vue&type=style&index=0&id=2abea2b4&prod&scoped=true&lang=less"
import style1 from "./legal_check.vue?vue&type=style&index=1&id=2abea2b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abea2b4",
  null
  
)

export default component.exports